/**
 * Admin Email Tracking Repository
 *
 * Manages email tracking for admin dashboard.
 */

import { createRepository } from 'data/utils/createRepository';
import { getApiUrl } from 'data/services/apiConstants';
import { get, post } from 'data/services/apiService';

const adminEmailTrackingRepository = createRepository({
	endpoint: 'admin/email-tracking',
	name: 'adminEmailTracking',
	statePath: 'adminEmailTracking',

	// Custom methods for email tracking operations
	customMethods: {
		/**
		 * Get email statistics
		 * Usage: actions.getStatistics({ days: 7 })
		 */
		getStatistics: ({ days = 7, authToken, dispatch }) => {
			return get({
				url: `${getApiUrl()}/api/admin/email-tracking/statistics?days=${days}`,
				authToken,
				dispatch,
			});
		},

		/**
		 * Retry failed email
		 * Usage: actions.retryEmail({ id: 123 })
		 */
		retryEmail: ({ id, authToken, dispatch }) => {
			return post({
				url: `${getApiUrl()}/api/admin/email-tracking/${id}/retry`,
				authToken,
				dispatch,
			});
		},

		/**
		 * Cleanup old emails
		 * Usage: actions.cleanup({ days: 90 })
		 */
		cleanup: ({ days = 90, authToken, dispatch }) => {
			return post({
				url: `${getApiUrl()}/api/admin/email-tracking/cleanup`,
				data: { days },
				authToken,
				dispatch,
			});
		},

		/**
		 * Get filter options
		 * Usage: actions.getFilterOptions()
		 */
		getFilterOptions: ({ authToken, dispatch }) => {
			return get({
				url: `${getApiUrl()}/api/admin/email-tracking/filter-options`,
				authToken,
				dispatch,
			});
		},
	},
});

// ============================================
// Exports
// ============================================

export const {
	name,
	statePath,
	thunks: adminEmailTrackingThunks,
	reducer: adminEmailTrackingReducer,
	actions: adminEmailTrackingActions,
	types: adminEmailTrackingTypes,
	selectors: adminEmailTrackingSelectors,
	useHook: useAdminEmailTracking,
} = adminEmailTrackingRepository;

export default adminEmailTrackingRepository;
